import React from 'react'
import getConfig from 'next/config'
import nookies from 'nookies'

import SvgAlert from '@ntuctech/devex-tangram/Icon/SvgAlert'
import SvgSuccess from '@ntuctech/devex-tangram/Icon/SvgSuccess'
import { get, patch, headers, post, put } from '../../../lib/fetch'
import { AUTH_TOKEN_KEY, SPLIT_FEATURES } from '../../../utils/constants'
import { getConfigFor } from '../../../utils/configService'
import { getPersonaApiPath } from '../../../utils/personaApiUtils'

const {
  publicRuntimeConfig: {
    STRUDEL_API,
    AUTH0_DOMAIN,
    AUTH0_CLIENT_ID,
    AUTH0_IDENTITY_API,
  },
} = getConfig()

const { [AUTH_TOKEN_KEY]: authToken } = nookies.get() || {}

export const EGIFT_VOUCHER_GIFT_CARD = 'eGift Cards'

export const initialState = {
  activeData: [],
  pastData: [],
  error: '',
  loading: true,
  toastData: {
    show: false,
    message: '',
    type: '',
    icon: '',
  },
  activeTab: 0,
  voucherDetails: {},
  showQrCode: false,
  showHowToUse: false,
  imgLoading: true,
  showFilter: false,
  activeFilter: { 0: 'All' },
  filteredData: [],
  showVerifySideSheet: false,
  receiverVoucherDetails: {},
  showCannotAddVcModal: false,
}

export const reducer = (state, action) => {
  let icon = <SvgSuccess />
  if (action.toastType === 'alert') {
    icon = <SvgAlert />
  }
  switch (action.type) {
    case 'SET_ACTIVE_DATA':
      return {
        ...state,
        activeData: action.value,
        loading: false,
        filteredData: action.filteredData,
      }
    case 'SET_PAST_DATA':
      return {
        ...state,
        pastData: action.value,
        loading: false,
        filteredData: action.filteredData,
      }
    case 'SET_ACTIVE_TAB':
      return {
        ...state,
        activeTab: action.value,
        imgLoading: true,
      }
    case 'SET_ACTIVE_FILTER_VALUE':
      return {
        ...state,
        activeFilter: action.filteredTag,
        filteredData: action.filteredData,
        showFilter: false,
      }
    case 'SHOW_QR_CODE':
      return {
        ...state,
        showQrCode: true,
        imgLoading: true,
      }
    case 'BACK_TO_VOUCHER_DETAILS':
      return {
        ...state,
        showQrCode: false,
        voucherDetails: action.value,
        imgLoading: false,
      }
    case 'BACK_TO_QRCODE_SCREEN':
      return {
        ...state,
        showQrCode: true,
        voucherDetails: action.value,
        showHowToUse: false,
      }
    case 'SET_ERROR':
      return { ...state, error: action.value }
    case 'TOGGLE_FILTER':
      return { ...state, showFilter: !state.showFilter }
    case 'SET_IMAGE_LOADING':
      return { ...state, imgLoading: true }
    case 'IMAGE_LOADED':
      return { ...state, imgLoading: false }
    case 'LOADING':
      return { ...state, loading: true }
    case 'SHOW_VOUCHER_DETAILS':
      return { ...state, voucherDetails: action.value }
    case 'SHOW_HOWTOUSE_DETAILS':
      return { ...state, showHowToUse: true, imgLoading: true }
    case 'SHOW_TOAST':
      return {
        ...state,
        toastData: {
          show: true,
          message: action.message,
          type: action.toastType,
          icon: icon,
        },
      }
    case 'HIDE_VOUCHER_DETAILS':
      return {
        ...state,
        voucherDetails: {},
        showQrCode: false,
        showHowToUse: false,
        imgLoading: false,
      }
    case 'HIDE_TOAST':
      return {
        ...state,
        toastData: {
          show: false,
        },
      }
    case 'SHOW_VERIFY_SIDE_SHEET':
      return {
        ...state,
        showVerifySideSheet: true,
      }
    case 'HIDE_VERIFY_SIDE_SHEET':
      return {
        ...state,
        showVerifySideSheet: false,
      }
    case 'GET_RECEIVER_VOUCHER_DETAILS':
      return {
        ...state,
        receiverVoucherDetails: action.value,
      }
    case 'SHOW_ADD_EGIFT_VC_MODAL':
      return {
        ...state,
        showAddEgiftVcModal: true,
      }
    case 'CLOSE_ADD_EGIFT_VC_MODAL':
      return {
        ...state,
        showAddEgiftVcModal: false,
      }
    case 'SHOW_CANNOT_ADDVC_MODAL':
      return {
        ...state,
        showCannotAddVcModal: true,
      }
    case 'HIDE_CANNOT_ADDVC_MODAL':
      return {
        ...state,
        showCannotAddVcModal: false,
      }
    default:
      return state
  }
}

const fetchWalletDetails = (status, variantKey = '') => {
  return get(
    `${STRUDEL_API}/me/wallet?experiments=${variantKey}&status=${status}`,
    {
      headers: {
        ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
        'Content-Type': 'application/json',
        'X-User-Source': 'fpon_web',
      },
    }
  )
}

const fetchWalletDetailsforPDP = (
  status,
  storeId,
  productId,
  variantKey,
  categoryIds
) => {
  return get(
    `${STRUDEL_API}/me/wallet?status=${status}&storeId=${storeId}&productId=${productId}&experiments=${variantKey}&categoryIds=${categoryIds}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'application/json',
        'X-User-Source': 'fpon_web',
      },
    }
  )
}

export const fetchWalletDataPDP = async (
  status,
  storeId,
  { dispatch },
  clientItemId,
  variantKey,
  categoryIds = ''
) => {
  try {
    const results = await fetchWalletDetailsforPDP(
      status,
      storeId,
      clientItemId,
      variantKey,
      categoryIds
    )
    if (status === 'active') {
      dispatch({
        type: 'SET_ACTIVE_DATA',
        value: results,
        filteredData: [],
      })
    }
  } catch (e) {
    dispatch({ type: 'SET_ERROR', value: e })
  }
}
export const fetchWalletData = async (
  status,
  activeFilter,
  { dispatch },
  variantKey,
  isEvoucherDeepLink
) => {
  try {
    const { isEnabled: isEGVChipFilterEnabled } = getConfigFor(
      SPLIT_FEATURES.FE_EGV_CHIP_FILTER
    )

    const orgResults = await fetchWalletDetails(status, variantKey)

    const results = {
      ...orgResults,
      newFilters: [
        ...(orgResults?.newFilters || []),
        ...(isEGVChipFilterEnabled
          ? [
              {
                name: EGIFT_VOUCHER_GIFT_CARD,
                rewardTags: [],
              },
            ]
          : []),
      ],
    }
    let filteredData = results.list
    if (parseInt(Object.keys(activeFilter)[0]) > 0) {
      filteredData = results.list?.filter(voucher =>
        voucher.tags.find(value => value === Object.values(activeFilter)[0])
      )
    }
    if (status === 'active') {
      dispatch({
        type: 'SET_ACTIVE_DATA',
        value: results,
        filteredData,
      })

      // if it is e voucher deeplink, preselect the eGift Cards filter chip
      if (isEvoucherDeepLink && isEGVChipFilterEnabled) {
        const filteredEVouchers = results.list?.filter(
          voucher => voucher.type === 'voucher'
        )
        dispatch({
          type: 'SET_ACTIVE_FILTER_VALUE',
          filteredTag: { '3': EGIFT_VOUCHER_GIFT_CARD },
          filteredData: filteredEVouchers,
        })
      }
    } else {
      dispatch({
        type: 'SET_PAST_DATA',
        value: results,
        filteredData,
      })
    }
  } catch (e) {
    dispatch({ type: 'SET_ERROR', value: e })
  }
}
export const storeVoucherCode = async (
  activeFilter,
  isVoucher,
  { code, dispatch },
  isEvoucherDeepLink,
  isVcControlEnabled
) => {
  try {
    const reqJson = { rewardType: isVoucher ? 'offer' : 'voucher', code }
    const result = await patch(`${STRUDEL_API}/me/wallet`, {
      body: JSON.stringify(reqJson),
      headers: headers(),
    })
    if (result) {
      dispatch({
        type: 'SHOW_TOAST',
        message: 'Successfully stored!',
        toastType: 'success',
      })
    }
  } catch (err) {
    if (isVcControlEnabled) {
      dispatch({ type: 'SHOW_CANNOT_ADDVC_MODAL' })
    } else {
      dispatch({
        type: 'SHOW_TOAST',
        message: err?.code ? err.message : err,
        toastType: 'alert',
      })
    }
  }
  fetchWalletData('active', activeFilter, { dispatch }, '', isEvoucherDeepLink)
}

export const getWalletDetails = code => {
  return get(`${STRUDEL_API}/me/rewards/${code}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
      'Content-Type': 'application/json',
      'X-User-Source': 'fpon_web',
    },
  })
}

export const mobilePasswordless = connectionValue => {
  const passwordlessApi = `https://${AUTH0_DOMAIN}/passwordless/start`
  return post(passwordlessApi, {
    body: JSON.stringify({
      client_id: AUTH0_CLIENT_ID,
      connection: 'ned-sms',
      send: 'code',
      phone_number: `+65${connectionValue.replaceAll(' ', '')}`,
    }),
    headers: { 'Content-Type': 'application/json' },
  })
}

export const verifyMobileOtp = (numberToBeVerified, otpValue) => {
  const verifyOtpApi = getPersonaApiPath('/user/phone', AUTH0_IDENTITY_API)
  return put(verifyOtpApi, {
    body: JSON.stringify({
      country_code: '65',
      phone_number: numberToBeVerified,
      verification_code: otpValue,
    }),
    headers: headers(),
  })
}
